var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchSeeklogocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59141 0L0 6.94864V34.7399H9.49742V39.9539H14.6826L19.8627 34.7399H27.6349L38 24.3215V0H2.59141ZM6.04388 3.47212H34.5461V22.5809L28.4989 28.6617H19L13.8214 33.8685V28.6617H6.04388V3.47212ZM15.5451 20.846H19V10.4245H15.5451V20.846ZM25.0447 20.846H28.4988V10.4245H25.0447V20.846Z",
    fill: "#8894A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchSeeklogocom);
export default __webpack_public_path__ + "static/media/twitch-seeklogo.com.38ac3b0e98abd6f5a328f459f981ac16.svg";
export { ForwardRef as ReactComponent };